"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOrUpdatePayment = exports.getCardValidatedState = exports.paymentInfo = exports.paymentError = exports.resetCard = exports.resetCardValidation = exports.validatePostalCode = exports.validateStripeElements = exports.restructurePostalCodeInputValue = exports.getPaymentInfo = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const userSlice_1 = require("./userSlice");
const store_1 = __importDefault(require("../store"));
const initialState = {
    payment: {
        cardType: 'card',
        last4: null,
        customerId: null,
        postalCode: '',
        balance: {
            availableAmount: 0,
            last4: null,
            brand: '',
        },
    },
    card: {
        postalCode: '',
        isValid: null,
        postalCodeValid: null,
    }
};
const paymentSlice = toolkit_1.createSlice({
    name: 'payment',
    initialState: initialState,
    reducers: {
        getPaymentInfo: (state, action) => {
            //state.card.postalCode = action.payload.postalCode
            state.payment = action.payload;
            return state;
        },
        restructurePostalCodeInputValue: (state, action) => {
            const value = action.payload;
            const x = value.replace(/\s/g, '').replace(/\D/g, '').match(/(\d{0,5})(\d{0,4})/);
            state.card.postalCode = !x[2] ? x[1] : x[1] + '-' + x[2];
            return state;
        },
        validatePostalCode: (state, action) => {
            const value = action.payload;
            if (value) {
                state.card.postalCodeValid = value.replace(/\s/g, '').length >= 5;
            }
            else {
                state.card.postalCodeValid = false;
            }
            return state;
        },
        validateStripeElements: (state, action) => {
            state.card.isValid = action.payload;
        },
        paymentError: (state, action) => {
        },
        resetCardValidation: (state, action) => {
            if (Array.isArray(action.payload)) {
                action.payload.forEach(el => {
                    state.card[el] = null;
                });
            }
            else {
                state.card[action.payload] = null;
            }
            return state;
        },
        resetCard: (state) => {
            state.card.postalCode = '';
            return state;
        }
    }
});
_a = paymentSlice.actions, exports.getPaymentInfo = _a.getPaymentInfo, exports.restructurePostalCodeInputValue = _a.restructurePostalCodeInputValue, exports.validateStripeElements = _a.validateStripeElements, exports.validatePostalCode = _a.validatePostalCode, exports.resetCardValidation = _a.resetCardValidation, exports.resetCard = _a.resetCard, exports.paymentError = _a.paymentError;
const paymentInfo = () => async (dispatch) => {
    try {
        const payload = await api_1.Payment.getPaymentInfo();
        dispatch(exports.getPaymentInfo(payload));
    }
    catch (e) {
        dispatch(exports.paymentError(e));
    }
};
exports.paymentInfo = paymentInfo;
const getCardValidatedState = () => {
    const card = store_1.default.getState().payment.card;
    return card.isValid && card.postalCodeValid;
};
exports.getCardValidatedState = getCardValidatedState;
const addOrUpdatePayment = stripeToken => async (dispatch) => {
    try {
        dispatch(userSlice_1.getUser());
        const user = store_1.default.getState().user;
        const data = {
            userId: user.id,
            roleType: user.roleType,
            userEmail: user.email,
            stripeData: stripeToken,
        };
        await api_1.Payment.addOrUpdatePayment(data);
        dispatch(exports.paymentInfo());
    }
    catch (e) {
        //dispatch(paymentError(e));
    }
};
exports.addOrUpdatePayment = addOrUpdatePayment;
exports.default = paymentSlice.reducer;
